export const saleApi1 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI1":
      return action.payload;
    case "REMOVE_SALEAPI1":
      return {};
    default:
      return state;
  }
};

export const saleApi2 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI2":
      return action.payload;
    case "REMOVE_SALEAPI2":
      return {};
    default:
      return state;
  }
};

export const saleApi3 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI3":
      return action.payload;
    case "REMOVE_SALEAPI3":
      return {};
    default:
      return state;
  }
};

export const saleApi4 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI4":
      return action.payload;
    case "REMOVE_SALEAPI4":
      return {};
    default:
      return state;
  }
};

export const saleApi5 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI5":
      return action.payload;
    case "REMOVE_SALEAPI5":
      return {};
    default:
      return state;
  }
};

export const saleApi6b = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI6B":
      return action.payload;
    case "REMOVE_SALEAPI6B":
      return {};
    default:
      return state;
  }
};

export const saleApi8 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI8":
      return action.payload;
    case "REMOVE_SALEAPI8":
      return {};
    default:
      return state;
  }
};

export const saleApi10 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI10":
      return action.payload;
    case "REMOVE_SALEAPI10":
      return {};
    default:
      return state;
  }
};

export const saleApi14 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI14":
      return action.payload;
    case "REMOVE_SALEAPI14":
      return {};
    default:
      return state;
  }
};

export const saleApi15 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI15":
      return action.payload;
    case "REMOVE_SALEAPI15":
      return {};
    default:
      return state;
  }
};

export const saleApi20 = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI20":
      return action.payload;
    case "REMOVE_SALEAPI20":
      return {};
    default:
      return state;
  }
};
export const saleApi20a = (state = {}, action) => {
  switch (action.type) {
    case "GET_SALEAPI20a":
      if (!action.payload || action.payload.length === 0) {
        const { [action.userType]: removed, ...rest } = state;
        return rest;
      }
      return { ...state, [action.userType]: action.payload };
          case "REMOVE_SALEAPI20a":
      return {};
    default:
      return state;
  }
};


const initialState = {
  parent: {},
  child: {}, 
};

export const salePerformance = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SALE_PARENT_DATA":
      return {
        ...state,
        parent: { ...state.parent, [action.userId]: action.payload },
      };
    case "SET_SALE_CHILD_DATA":
      return {
        ...state,
        child: { ...state.child, [action.userId]: action.payload },
      };
    case "RESET_SALE_DATA":
      return initialState;
    default:
      return state;
  }
};



// tab start from here 


export const tabSale10 = (state = [], action) => {
    switch (action.type) {
        case 'GET_TAB10_SALE':
  		    return action.payload
        case 'REMOVE_TAB10_SALE':
            return {}
    default:
        return state
    }
}

export const tabSale11 = (state = [], action) => {
    switch (action.type) {
        case 'GET_TAB11_SALE':
  		    return action.payload
        case 'REMOVE_TAB11_SALE':
            return {}
    default:
        return state
    }
}

export const tabSale5 = (state = [], action) => {
    switch (action.type) {
        case 'GET_TAB5_SALE':
  		    return action.payload
        case 'REMOVE_TAB5_SALE':
            return {}
    default:
        return state
    }
}

export const tabSale6 = (state = [], action) => {
    switch (action.type) {
        case 'GET_TAB6_SALE':
  		    return action.payload
        case 'REMOVE_TAB6_SALE':
            return {}
    default:
        return state
    }
}

export const tabSale7 = (state = [], action) => {
    switch (action.type) {
        case 'GET_TAB7_SALE':
  		    return action.payload
        case 'REMOVE_TAB7_SALE':
            return {}
    default:
        return state
    }
}

export const tabSale8 = (state = [], action) => {
    switch (action.type) {
        case 'GET_TAB8_SALE':
  		    return action.payload
        case 'REMOVE_TAB8_SALE':
            return {}
    default:
        return state
    }
}

export const tabSale9 = (state = [], action) => {
    switch (action.type) {
        case 'GET_TAB9_SALE':
  		    return action.payload
        case 'REMOVE_TAB9_SALE':
            return {}
    default:
        return state
    }
}